<div class="formly-field-turnstile">
  <div #turnstileContainer class="turnstile-container"></div>
  <div *ngIf="showError && formControl.errors" class="invalid-feedback d-block">
    <span *ngIf="formControl.errors.required">{{ "This field is required" | translate }}</span>
    <span *ngIf="formControl.errors.captchaError">{{
      "Captcha verification failed. Please try again." | translate
    }}</span>
    <span *ngIf="formControl.errors.captchaExpired">{{ "Captcha expired. Please verify again." | translate }}</span>
  </div>
</div>
